<template>
  <main class="show-thread">
    <dl class="show-thread__summary">
      <div class="show-thread__summary-item">
        <dt class="show-thread__summary-title">Status</dt>
        <dd class="show-thread__summary-value">
          {{ states[threadInfo.state] }}

          <template v-if="threadInfo.read.unreadContent.you || true">
            <span
              class="show-thread__badge"
              v-if="['message', 'message_and_attachment'].includes(threadInfo.read.unreadContent.you) || true"
            >
              Nowa wiadomość
            </span>
            <span
              class="show-thread__badge"
              v-if="['attachment', 'message_and_attachment'].includes(threadInfo.read.unreadContent.you)"
            >
              Nowy plik
            </span>
          </template>

          <span class="show-thread__badge show-thread__badge--red" v-if="threadInfo.urgent">
            Priorytetowe
          </span>
        </dd>
      </div>
      <div class="show-thread__summary-item">
        <dt class="show-thread__summary-title">Data zgłoszenia</dt>
        <dd class="show-thread__summary-value">{{ threadInfo.startedAt }}</dd>
      </div>
      <div class="show-thread__summary-item">
        <dt class="show-thread__summary-title">Płeć</dt>
        <dd class="show-thread__summary-value">{{ threadInfo.patient.gender === "male" ? "Mężczyzna" : "Kobieta" }}</dd>
      </div>
      <div class="show-thread__summary-item">
        <dt class="show-thread__summary-title">Wiek</dt>
        <dd class="show-thread__summary-value">{{ threadInfo.patient.age }} l.</dd>
      </div>
    </dl>

    <Thread :current-report="this.$route.params.id" />
  </main>
</template>

<script>
import axios from "axios";
import Thread from "@/components/messages/Thread";
import { mapGetters } from "vuex";

export default {
  name: "ShowReport",
  components: {
    Thread,
  },
  computed: mapGetters({
    headers: "getSecuredRequestHeader",
  }),
  data() {
    return {
      threadInfo: null,
      states: {
        new: "Nowe",
        acknowledged: "Przyjęte",
        ongoing: "W toku",
        resolved: "Rozwiązane",
      },
    };
  },
  beforeMount() {
    axios.get(`${process.env.VUE_APP_API_URL}/medical-report/`, { headers: this.headers }).then((response) => {
      this.threadInfo = response.data.find((item) => item.id === this.$route.params.id);
      console.log(this.threadInfo);
    });
  },
};
</script>

<style lang="scss">
.show-thread {
  max-width: 1600px;
  width: calc(100% - 1rem);
  margin: 2rem auto;
  border-radius: 1rem;
  background: #fff;
  border: 1px solid #e1e1e1;
  overflow: hidden;

  &__badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 2px 8px 2px 4px;
    border: 2px solid #e1e1e1;
    color: gray;
    border-radius: 20px;
    font-size: 12px;

    &:before {
      content: " ";
      display: inline-block;
      width: 15px;
      height: 15px;
      right: 0;
      background: #36baca;
      border-radius: 15px;
      transition: all 200ms;
      flex-shrink: 0;
    }

    &--red {
      background: #fde8e8;
      color: #e55353;
      border: 1px solid #e55353;

      &:before {
        background: #e55353;
      }
    }
  }

  &__summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    border-bottom: 1px solid #e1e1e1;
    background: #f9f9f9;

    &-item {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding: 0 1rem;
      margin: 1rem 0;

      &:not(:last-of-type) {
        border-right: 1px solid #e1e1e1;
      }
    }

    &-value {
      font-weight: bold;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &-title {
      font-size: 14px;
      margin-bottom: 8px;
    }
  }
}
</style>
